import Store from 'lib/Store/withLocalStorage';

import config from 'config/general';

const authStore = Store(`${config.localStorageKey}-auth`);

const formatSurveyData = (data: any): { [key: string]: string } => {
  const formattedData: { [key: string]: string } = {};

  Object.entries(data).forEach(([key, values]) => {
    if (Array.isArray(values)) {
      formattedData[key] = values
        .map((item) => {
          if (typeof item === 'string') {
            const parts = item.split(' / ');
            return parts[parts.length - 1].trim();
          }
          return '';
        })
        .filter(Boolean)
        .join(', ');
    }
  });

  return formattedData;
};

export const middlewareUser = (data: any): IUser => ({
  cacheKey: authStore.getItem('token') || data?.id || '',

  user: {
    id: data?.id || '',
    email: data?.email || '',
    phone: data?.phone || '',
    name: data?.name || '',
    lastname: data?.lastname || '',
    fullname: `${data?.name} ${data?.lastname}` || '',
    role: data?.role || '',
    site: data?.site || '',
    about: data?.about || '',
    avatar: data?.profile_image || '',
    observation: data?.observation || '',
    companyFantasyName: data?.company || '',
    type: data?.whitelabel_type || '',
    table: data?.additional || '',
    language: data?.language || '',
  },

  typeUser: data?.whitelabel_type || '',
  interests: formatSurveyData(data?.surveys_answers),
});
